import React from 'react';
import { Skeleton } from '@atlassian/jira-common-components-skeleton/src/styled.tsx';

export const FieldLoader = (): React.JSX.Element => <Skeleton width="350px" height="40px" />;
